import {BehaviorSubject} from 'rxjs';

import UiEventType            from '../../Ui/Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../Ui/Shared/Interfaces/IUiEventsStreamPayload';
import IEventBinding          from '../Interfaces/IEventBinding';
import Player                 from '../Player';

const bindRootMouseLeaveEvent = (player: Player): IEventBinding => {
    const handler = (): void => (player.ui.uiEvents$ as BehaviorSubject<IUiEventsStreamPayload>)
        .next({
            type: UiEventType.FRAME_MOUSE_LEAVE
        });

    const target =
        player.state.stores.config.value.behaviour.fullscreenElement ||
        player.refs.root;

    target.addEventListener('mouseleave', handler);

    const release = () => target.removeEventListener('mouseleave', handler);

    return {
        release
    };
};

export default bindRootMouseLeaveEvent;